module.exports = __webpack_public_path__ + "img/userid-tip.38a2814.jpg";